import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IButton } from '../../atoms/button/button.interface';
import { IFaIcon } from '../../atoms/fa.icon/fa.icon.interface';
import { INotificationList } from './notification.list.interface';

@Component({
    selector: 'mlp-ng-notification-list',
    templateUrl: './notification.list.component.html',
    styleUrls: ['./notification.list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class NotificationListSharedComponent implements OnInit {
    @Input() data: INotificationList;
    @Output() event = new EventEmitter();
    typeData: any;

    get icon(): IFaIcon {
        return {
            name: this.typeData.name,
            size: 'fa-lg'
        };
    }

    get button(): IButton {
        return {
            label: this.typeData.label
        };
    }

    ngOnInit(): void {
        this.typeData = this.getType();
    }

    getType(): any {
        switch (this.data.status) {
            case 'info':
                return this.setInfo('info', this.data.icon);
            case 'warning':
                return this.setInfo('warning');
            default:
                return this.setInfo();
        }
    }

    setInfo(status = '', icon = ''): { name: string; color: string } {
        let name = 'check-circle';
        let color = '';

        if (status === 'warning') {
            name = 'exclamation-triangle';
            color = '-warning';
        }

        if (status === 'info') {
            name = icon;
            color = '-info';
        }

        return {
            name,
            color
        };
    }
}
